export const METRIC_LABELS_TO_VALUES = (isAnalyticsBotFiltering: boolean) => ({
  // Email metrics
  'Average Order Value': 'AverageOrderValue',
  'Clicks / Opens': 'EmailClickPerOpenRate',
  'Complaint Rate': 'TotalEmailComplaintRate',
  'Conversions / Email Hold Outs': 'ConversionPerEmailHoldOutRate',
  'Conversions / Unique Emails Delivered': 'ConversionPerEmailDeliveredRate',
  'Email Bounce Rate': 'EmailBounceRate',
  'Email Click Rate': 'EmailClickRate',
  'Email Delivery Rate': 'EmailDeliveryRate',
  'Email Open Rate': 'EmailOpenRate',
  'Email Unsubscribe Rate': 'EmailUnsubscribeRate',
  'Purchases / M (Email)': 'PurchasePerEmailSendMille',
  'Revenue / M (Email)': 'RevenuePerEmailSendMille',
  Revenue: 'Revenue',
  'Total Complaints': 'TotalEmailComplaint',
  'Total Email Holdout': 'TotalEmailHoldOut',
  'Total Email Opens': 'TotalEmailOpen',
  'Total Email Opens (filtered)': isAnalyticsBotFiltering
    ? 'TotalEmailOpensBotFiltered'
    : 'TotalEmailOpensFiltered',
  'Total Email Send Skips': 'TotalEmailSendSkip',
  'Total Email Sends': 'TotalEmailSend',
  'Total Emails Bounced': 'TotalEmailBounce',
  'Total Emails Clicked': 'TotalEmailClick',
  'Total Emails Clicked (filtered)': 'TotalEmailClickBotFiltered',
  'Total Emails Delivered': 'TotalEmailDelivered',
  'Total Hosted Unsubscribe Clicks': 'TotalHostedUnsubscribeClick',
  'Total Purchases': 'TotalPurchase',
  'Total Unsubscribes': 'TotalUnsubscribe',
  'Unique Email Click Rate': 'UniqueEmailClickRate',
  'Unique Email Clicks': 'UniqueEmailClick',
  'Unique Email Clicks (filtered)': 'UniqueEmailClickBotFiltered',
  'Unique Email Open Rate': 'UniqueEmailOpenRate',
  'Unique Email Opens (filtered)': isAnalyticsBotFiltering
    ? 'UniqueEmailOpensBotFiltered'
    : 'UniqueEmailOpensFiltered',
  'Unique Email Opens Or Clicks': 'UniqueEmailOpenOrClick',
  'Unique Email Opens': 'UniqueEmailOpen',
  'Unique Email Sends': 'UniqueEmailSend',
  'Unique Emails Bounced': 'UniqueEmailBounce',
  'Unique Emails Delivered': 'UniqueEmailDelivered',
  'Unique Hosted Unsubscribe Clicks': 'UniqueHostedUnsubscribeClick',
  'Unique Purchases': 'UniquePurchase',
  'Unique Unsubscribes': 'UniqueUnsubscribe',

  // Push metrics
  'Conversions / Push Hold Outs': 'ConversionPerPushHoldOutRate',
  'Conversions / Unique Pushes Delivered': 'ConversionPerPushDeliveredRate',
  'Push Bounce Rate': 'PushBounceRate',
  'Push Delivery Rate': 'PushDeliveryRate',
  'Push Open Rate': 'PushOpenRate',
  'Push Unsubscribe Rate': 'PushUnsubscribeRate',
  'Purchases / M (Push)': 'PurchasePerPushSendMille',
  'Revenue / M (Push)': 'RevenuePerPushSendMille',
  'Total App Uninstalls': 'TotalPushUninstall',
  'Total Push Holdout': 'TotalPushHoldOut',
  'Total Push Send Skips': 'TotalPushSendSkip',
  'Total Pushes Bounced': 'TotalPushBounce',
  'Total Pushes Delivered': 'TotalPushDelivered',
  'Total Pushes Opened': 'TotalPushOpen',
  'Total Pushes Sent': 'TotalPushSend',
  'Unique Push Open Rate': 'UniquePushOpenRate',
  'Unique Pushes Bounced': 'UniquePushBounce',
  'Unique Pushes Delivered': 'UniquePushDelivered',
  'Unique Pushes Opened': 'UniquePushOpen',
  'Unique Pushes Sent': 'UniquePushSend',

  // SMS metrics
  'Conversions / SMS Hold Outs': 'ConversionPerSMSHoldOutRate',
  'Conversions / Unique SMS Delivered': 'ConversionPerSMSDeliveredRate',
  'Conversions / Unique SMS Sends': 'ConversionPerSMSSendRate',
  'Purchases / M (SMS)': 'PurchasePerSMSSendMille',
  'Revenue / M (SMS)': 'RevenuePerSMSSendMille',
  'SMS Bounce Rate': 'SMSBounceRate',
  'SMS Click Rate': 'SMSClickRate',
  'SMS Delivery Rate': 'SMSDeliveryRate',
  'SMS Unsubscribe Rate': 'SMSUnsubscribeRate',
  'Total SMS Bounced': 'TotalSMSBounce',
  'Total SMS Delivered': 'TotalSMSDelivered',
  'Total SMS Holdout': 'TotalSMSHoldOut',
  'Total SMS Send Skips': 'TotalSMSSendSkip',
  'Total SMS Sent': 'TotalSMSSend',
  'Total SMS Clicks': 'TotalSMSClick',
  'Total SMS Clicks (filtered)': 'TotalSMSClickBotFiltered',
  'Total Inbound SMS': 'TotalSMSInbound',
  'Unique SMS Bounced': 'UniqueSMSBounce',
  'Unique SMS Click Rate': 'UniqueSMSClickRate',
  'Unique SMS Clicks': 'UniqueSMSClick',
  'Unique SMS Clicks (filtered)': 'UniqueSMSClickBotFiltered',
  'Unique SMS Delivered': 'UniqueSMSDelivered',
  'Unique SMS Sent': 'UniqueSMSSend',
  'Unique Inbound SMS': 'UniqueSMSInbound',

  // Web Push metrics
  'Conversions / Web Push Hold Outs': 'ConversionPerWebPushHoldOutRate',
  'Conversions / Unique Web Push Sends': 'ConversionPerWebPushSendRate',
  'Total Web Push Clicks': 'TotalWebPushClick',
  'Total Web Push Send Skips': 'TotalWebPushSendSkip',
  'Total Web Pushes Sent': 'TotalWebPushSend',
  'Total WebPush Holdout': 'TotalWebPushHoldOut',
  'Unique Web Push Clicks': 'UniqueWebPushClick',
  'Unique Web Pushes Sent': 'UniqueWebPushSend',

  // In-app metrics
  'Conversions / In-app Hold Outs': 'ConversionPerInAppHoldOutRate',
  'Conversions / Unique In-app Opens': 'ConversionPerInAppOpenRate',
  'In-app Click Rate': 'InAppClickRate',
  'Total In-app Clicks': 'TotalInAppClick',
  'Total In-app Closes': 'TotalInAppClose',
  'Total In-app Deletes': 'TotalInAppDelete',
  'Total In-app Holdout': 'TotalInAppHoldOut',
  'Total In-app Opens': 'TotalInAppOpen',
  'Total In-app Sent': 'TotalInAppSend',
  'Total In-app Send Skips': 'TotalInAppSendSkip',
  'Total Inbox Impressions': 'TotalInboxImpression',
  'Total In-apps Delivered': 'TotalInAppDelivery',
  'Unique In-app Click Rate': 'UniqueInAppClickRate',
  'Unique In-app Clicks': 'UniqueInAppClick',
  'Unique In-apps Delivered': 'UniqueInAppDelivered',
  'Unique In-app Open Rate': 'UniqueInAppOpenRate',
  'Unique In-app Opens': 'UniqueInAppOpen',
  'Unique In-app Sends': 'UniqueInAppSend',

  // Embedded metrics
  'Embedded Click Rate': 'EmbeddedClickRate',
  'Embedded Impressions Rate': 'EmbeddedImpressionsRate',
  'Total Embedded Clicks': 'TotalEmbeddedClick',
  'Total Embedded Impressions': 'TotalEmbeddedImpression',
  'Total Embedded Retrieved': 'TotalEmbeddedRetrieved',
  'Unique Embedded Clicks': 'UniqueEmbeddedClick',
  'Unique Embedded Impressions': 'UniqueEmbeddedImpression',
  'Unique Embedded Retrieved': 'UniqueEmbeddedRetrieved',

  // WhatsApp metrics
  'Clicks / Reads': 'WhatsAppClickPerReadRate',
  'Conversions / Unique WhatsApp Delivered': 'ConversionPerWhatsAppDeliveredRate',
  'Purchases / M (WhatsApp)': 'PurchasesPerWhatsAppSendMille',
  'Revenue / M (WhatsApp)': 'RevenuePerWhatsAppSendMille',
  'Total WhatsApp Bounced': 'TotalWhatsAppBounce',
  'Total WhatsApp Clicks': 'TotalWhatsAppClick',
  'Total WhatsApp Delivered': 'TotalWhatsAppDelivered',
  'Total WhatsApp Inbound': 'TotalWhatsAppInbound',
  'Total WhatsApp Reads': 'TotalWhatsAppRead',
  'Total WhatsApp Send Skips': 'TotalWhatsAppSendSkip',
  'Total WhatsApp Sends': 'TotalWhatsAppSend',
  'Unique WhatsApp Bounced': 'UniqueWhatsAppBounce',
  'Unique WhatsApp Click Rate': 'UniqueWhatsAppClickRate',
  'Unique WhatsApp Clicks': 'UniqueWhatsAppClick',
  'Unique WhatsApp Delivered': 'UniqueWhatsAppDelivered',
  'Unique WhatsApp Reads': 'UniqueWhatsAppRead',
  'Unique WhatsApp Reads Or Clicks': 'UniqueWhatsAppReadOrClick',
  'Unique WhatsApp Read Rate': 'UniqueWhatsAppReadRate',
  'Unique WhatsApp Sends': 'UniqueWhatsAppSend',
  'WhatsApp Bounce Rate': 'WhatsAppBounceRate',
  'WhatsApp Click Rate': 'WhatsAppClickRate',
  'WhatsApp Delivery Rate': 'WhatsAppDeliveryRate',
  'WhatsApp Read Rate': 'WhatsAppReadRate',
  'WhatsApp Unsubscribe Rate': 'WhatsAppUnsubscribeRate',

  // Custom Conversion metrics
  'Average Custom Conversion Value': 'AverageCustomConversionValue',
  'Sum of Custom Conversions': 'SumCustomConversion',
  'Total Custom Conversions': 'TotalCustomConversion',
  'Unique Custom Conversions': 'UniqueCustomConversion',
});

export const HIGH_LEVEL_LABELS_TO_VALUES = {
  'Total Sent': 'TotalSent',
  'Total Send Skips': 'TotalSendSkips',
  'Total Delivered': 'TotalDelivered',
  'Delivery Rate': 'DeliveryRate',
  'Total Opens': 'TotalOpens',
  'Unique Opens': 'UniqueOpens',
  'Unique Open Rate': 'UniqueOpenRate',
  'Total Clicks': 'TotalClicks',
  'Unique Clicks': 'UniqueClicks',
  'Click Rate': 'ClickRate',
  'Clicks / Opens': 'ClicksPerOpensRate',
  'Total Unsubscribes': 'TotalUnsubscribes',
  'Unsubscribe Rate': 'UnsubscribeRate',
  'Total App Uninstalls': 'TotalUninstalls',
  'Total Complaints': 'TotalComplaints',
  'Total Bounces': 'TotalBounces',
  'Total Replies': 'TotalReplies',
  'Bounce Rate': 'BounceRate',
  'Total Purchases': 'TotalPurchases',
  Revenue: 'Revenue',
  'Revenue / M': 'RevenuePerMille',
  'Purchases / M': 'PurchasesPerMille',
  'Total Conversions': 'TotalCustomConversions',
  'Conversions / Send Delivered': 'ConversionPerSendRate',
  'Conversions / Hold Out': 'ConversionPerHoldOutRate',
  'Open Rate': 'OpenRate',
};
